export default "__VITE_ASSET__cfe217fc__";